import React from "react";
import queryString from "query-string";
import nProgress from "nprogress";
import Bowser from "bowser";
import PageWrapper from "./src/components/PageWrapper/PageWrapper";
import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";
import posthog from "posthog-js";
import Cookies from 'js-cookie';

import "./src/styles/tailwindStyle.scss";
import { AnalyticData } from "@/interface/analyticData.interface";
import { config } from "./src/config";

const defaultAnalytics = {
        sessionStarted: new Date().toISOString(),
        pageView: 1,
        pagesView: [location.href]
      };

// Wrap all pages with PageWrapper to ensure context is available everywhere
export const wrapRootElement = ({ element }) => {
  return <PageWrapper>{element}</PageWrapper>;
};

export const onClientEntry = () => {
  try {
  
  const parsed: any = queryString.parse(window.location.search) || {};
  if (document.referrer) {
    parsed.referrer = document.referrer;
  }
  parsed.browser = Bowser.parse(window.navigator.userAgent);
  sessionStorage.setItem("utm_source", JSON.stringify(parsed));
  nProgress.configure({ showSpinner: false });

    let analyticData: Partial<AnalyticData>  = defaultAnalytics;

    if (analyticData) {
      analyticData =  Cookies.get(config.analytics_cookie) ? JSON.parse(Cookies.get(config.analytics_cookie) as string) : defaultAnalytics;
    } else {
      analyticData = {
        sessionStarted: new Date().toISOString(),
        pageView: 1,
        pagesView: [location.href]
      };
    }

  Cookies.set(config.analytics_cookie, JSON.stringify(analyticData), { expires: 1 });

  if (!sessionStorage.getItem("landing_page")) {
    sessionStorage.setItem("landing_page", location.href);
  }

  const options = {
    init: {
      distributed_tracing: { enabled: true },
      privacy: { cookies_enabled: true },
      ajax: { deny_list: ["bam.nr-data.net"] },
    }, // NREUM.init
    info: {
      beacon: "bam.nr-data.net",
      errorBeacon: "bam.nr-data.net",
      licenseKey: "NRJS-b056381a71846e7084e",
      applicationID: "1589032242",
      sa: 1,
    }, // NREUM.info
    loader_config: {
      accountID: "6230937",
      trustKey: "6230937",
      agentID: "1589032242",
      licenseKey: "NRJS-b056381a71846e7084e",
      applicationID: "1589032242",
    }, // NREUM.loader_config
  };

  if (process.env.GATSBY_IS_PRODUCTION_DOMAIN === 'true') {
    // The agent loader code executes immediately on instantiation.
    new BrowserAgent(options);
  }

  // Function to get URL param
  function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  if (process.env.GATSBY_IS_PRODUCTION_DOMAIN === 'true') {
    posthog.init("phc_ruRGJ7yj0prMitFtB7N8A0jofmckODxzGlcZc6u5kQB", {
      api_host: "https://us.i.posthog.com",
      person_profiles: "identified_only",
      loaded: (posthog) => {
        // Get gclid from URL if present
        const gclid = getQueryParam("gad_campaignid");
        if (gclid) {
          // Identify user with gclid & source info immediately
          posthog.identify(undefined, {
            source: "google_ads",
            gclid: gclid,
          });
        }

        if (getQueryParam("gad_campaignid")) {
          localStorage.setItem('disable_ui_ux_form', 'true');
          posthog.capture("visited_with_gad_campaignid", {
            url: window.location.href,
            gad_campaignid: new URLSearchParams(window.location.search).get(
              "gad_campaignid"
            ),
          });
        }
      },
    });
  }
  } catch (e) {
    console.log(e)
  }
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (location.pathname !== prevLocation?.pathname) {
    nProgress.done();


    try {
      const analyticData: AnalyticData = Cookies.get(config.analytics_cookie) ? JSON.parse(Cookies.get(config.analytics_cookie) as string) : defaultAnalytics;
      analyticData.pageView = analyticData.pageView + 1;
      analyticData.pagesView.push(location.href);

      Cookies.set(config.analytics_cookie, JSON.stringify(analyticData), { expires: 1 });
    } catch (e) {
      console.log(e);
    }
    
  }
};

export const onRouteUpdateDelayed = () => {
  nProgress.start();
};

export const wrapPageElement = ({ element, props }) => {
  return (
    <PageWrapper {...props}>
      {element}
    </PageWrapper>
  );
};
